import { render } from "./NavPreHome.vue?vue&type=template&id=c6b1a316&scoped=true"
const script = {}

import "./NavPreHome.vue?vue&type=style&index=0&id=c6b1a316&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6b1a316"]])

export default __exports__